module.exports = __webpack_public_path__ + "img/travel_step2_sucs.56ecade4.svg";